module.exports = __webpack_public_path__ + "img/Logs.dc0c0f96.svg";